import cuid from 'cuid'
import { observer } from 'mobx-react'
import React, { Suspense, useEffect, useRef, useState } from 'react'
import Modal from '../../Components/Modal'
import LayoutStore from '../../State/LayoutStore'
import InvoiceSettingsModal from '../InvoiceListPage/InvoiceSettingsModal'
import ImportOneContactModal from '../ContactListPage/ImportOneContactModal'
import ImportContactsModal from '../ContactListPage/ImportContactsModal'

export default observer(({ modal }) => {
    return [
        ...LayoutStore.modals.values(),
        ...(modal === 'invoice-settings'
            ? [<InvoiceSettingsModal modalId={'invoice-settings'} />]
            : []),
        ...(modal === 'import-one-contact'
            ? [
                  <ImportOneContactModal
                      modalId={'import-one-contact'}
                      onSave={() => {}}
                  />,
              ]
            : []),
        ...(modal === 'import-contacts'
            ? [<ImportContactsModal modalId={'import-contacts'} />]
            : []),
    ]
})
